<template>
  <!-- 系统消息弹窗 - 文章类通知（简约清爽款） -->
  <el-dialog
    :title="messageData?.title || '最新系统通知'"
    :visible="visible"
    width="800px"
    :close-on-click-modal="false"
    :show-close="true"
    @close="handleClose"
    :modal="false"
    top="5vh"
    class="simple-article-dialog"
  >
    <!-- 文章式消息内容 -->
    <div class="article-wrap">
      <!-- 头部信息：时间+来源标识 -->
      <div class="article-head">
        <span class="msg-tag">{{ messageData?.msgType || '未知公告' }}</span>
        <span class="publish-time">{{ formatTime(messageData?.createTime) }}</span>
      </div>
      <!-- 正文区域（核心优化） -->
      <quill-viewer  class="article-main" :content="messageData?.content || '暂无通知内容'"></quill-viewer>
    </div>
  </el-dialog>
</template>

<script>
import QuillViewer from "@/components/QuillViewer/index.vue";
import {changeStatus} from "@/axios/sysAnnouncement/myAnnouncementList";

export default {
  name: 'SystemMessageDialog',
  components: {QuillViewer},
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    messageData: {
      type: Object,
      required: true,
      default: () => ({
        id: null,
        title: null,
        content: null,
        msgType: null,
        createTime: null
      })
    }
  },
  methods: {
    async requestChangeStatus(noticeId){
      if(noticeId){
        const changeStatusRes = await changeStatus(noticeId);
        if (changeStatusRes.errorCode === 0) {
          // TODO 刷新列表
          // this.$messageInstance.loadPage()
        }
      }else {
        console.log('noticeId:'+noticeId)
      }

    },
    formatTime(time) {
      if (!time) return '';
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close', this.messageData);
      this.requestChangeStatus(this.messageData.id)
    }
  }
};
</script>

<style scoped>
/* 弹窗整体：去掉遮罩后优化边框+阴影，更突出弹窗本体 */
.simple-article-dialog {
  border-radius: 10px !important;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15) !important; /* 降低阴影浓度，更自然 */
  border: 1px solid #e8e8e8 !important;
  overflow: hidden;
  text-align: center;
}

/* 标题栏：微调间距+背景，更轻盈 */
::v-deep .el-dialog__header {
  line-height: 30px;
  padding: 16px 24px !important;
  border-bottom: 1px solid #f5f7fa;
  background-color: #fafbfc;
}
::v-deep .el-dialog__title {
  font-size: 17px !important;
  font-weight: 600 !important;
  color: #131517 !important;
}
::v-deep .el-dialog__close {
  color: #a0aec0 !important;
  font-size: 18px !important;
  margin-top: 0; /* 修正垂直居中，移除多余margin */
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-dialog__close:hover {
  color: #4299e1 !important;
  transform: scale(1.1);
  transition: all 0.2s;
}

/* 弹窗内容区：优化内边距，适配正文容器 */
::v-deep .el-dialog__body {
  padding: 10px 24px !important; /* 恢复合理内边距，避免拥挤 */
  background-color: #ffffff;
  max-height: 75vh; /* 限制内容区高度，防止弹窗过高 */
  overflow: hidden;
}

/* 文章容器：微调间距，更协调 */
.article-wrap {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 恢复合理间距，提升呼吸感 */
}

/* 文章头部：优化分隔线+标签样式 */
.article-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f2f5;
  line-height: 25px;
}
.publish-time {
  font-size: 13px;
  color: #38414a;
}
.msg-tag {
  line-height: 20px;
  font-size: 12px;
  color: #4299e1;
  background-color: #ebf8ff;
  padding: 3px;
  border-radius: 6px;
}

/* 文章正文：核心优化 - 边距、图片、排版、滚动 */
.article-main {
  /* 基础边距 */
  padding: 16px 20px;
  max-height: calc(70vh - 120px); /* 计算最大高度，适配弹窗 */
  overflow-y: auto; /* 内容超出时纵向滚动 */
}

/* 底部按钮：微调尺寸+hover效果，无遮罩时更醒目 */
.article-foot {
  display: flex;
  justify-content: center;
}
.article-foot .el-button {
  padding: 15px 32px;
  border-radius: 6px;
  font-size: 14px;
  background-color: #4299e1;
  border: none;
}
.article-foot .el-button:hover {
  background-color: #3182ce;
  box-shadow: 0 4px 12px rgba(66,153,225,0.25);
  transition: all 0.2s;
}

</style>
